// extracted by mini-css-extract-plugin
export var button__primary = "styles-module--button__primary--f3ff1";
export var col1 = "styles-module--col1--7e58b";
export var col2 = "styles-module--col2--09025";
export var col3 = "styles-module--col3--a5a21";
export var cursor = "styles-module--cursor--46ed6";
export var cursorFollower = "styles-module--cursor-follower--0d044";
export var headingCentered = "styles-module--heading-centered--14b2e";
export var logo = "styles-module--logo--65bd9";
export var noScroll = "styles-module--no-scroll--50fc7";
export var pageTemplatePageGame = "styles-module--page-template-page-game--e23ed";
export var phrase = "styles-module--phrase--c8a3e";
export var section__wrapper = "styles-module--section__wrapper--c6d5a";
export var section__wrapperLarge = "styles-module--section__wrapper--large--c6f2f";